<script setup lang="ts">
import { NIcon } from 'naive-ui';
import GaiaTooltip from '@/components/design/base/GaiaTooltip.vue';
import { gaiaNeutral } from '@/components/design/themes/tokens';

/**
 * The author's guidance for a field, behind a "?" beside its label. The form
 * stays as compact as it was, and the advice is a hover away rather than a
 * paragraph between every label and its input.
 */
defineProps<{ text: string }>();

const muted = gaiaNeutral.textMuted;
</script>

<template>
  <gaia-tooltip placement="top" :max-width="360">
    <template #trigger>
      <span
        role="img"
        aria-label="Guidance"
        :style="{ display: 'inline-flex', color: muted, cursor: 'help' }"
      >
        <n-icon :size="14"><question-circle-outlined /></n-icon>
      </span>
    </template>
    <span :style="{ whiteSpace: 'pre-wrap' }">{{ text }}</span>
  </gaia-tooltip>
</template>
